export class RockMilestone {
    id!: string
    rockId!: string
    userId!: string
    name!: string
    dueDate!: Date
    doneDate!: Date

    userIds: string[] = [] // Multiple user can only be assigned when adding a new ToDo, and multiple ToDos will be created for each user
}
